import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { UserLabel } from '@/components/ui/user-label'
import { staffUserName, useCurrentUser, useStaffUsers } from '../models/user'

interface SalesOwnerFilterProps {
  value: string
  onValueChange: (value: string) => void
  className?: string
}

export function SalesOwnerFilter({
  value,
  onValueChange,
  className = 'w-[180px] border-neutral-300 data-[size=default]:h-11',
}: SalesOwnerFilterProps) {
  const { user } = useCurrentUser({ enabled: true })
  const { staffUsers } = useStaffUsers({ assigned: true })

  return (
    <Select value={value || 'all'} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Sales owner" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All sales owners</SelectItem>
        {user && <SelectItem value="me">Mine</SelectItem>}
        <SelectItem value="unassigned">Unassigned</SelectItem>
        <SelectSeparator />
        {[...staffUsers]
          .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`))
          .map((u) => (
            <SelectItem key={u.id} value={u.id}>
              <UserLabel name={staffUserName(u)} src={u.avatar} />
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  )
}
